import React, { useEffect, useState, useRef, useCallback, useImperativeHandle } from 'react';
import { ContentEditor } from './contentEditor';
import classnames from 'classnames';
import { debounce } from 'lodash';
import { getIn18Text } from 'api';
import style from './contentRoot.module.scss';
import { guardString } from '../utils';
import { message, Popover } from 'antd';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { edmDataTracker } from '../tracker/tracker';
import { useActions, MailProductActions } from '@web-common/state/createStore';
import Button from '@web-common/components/UI/Button';
import { checkContentSize } from './utils/checkContentSize';
import cloneDeep from 'lodash/cloneDeep';
import TongyongJiantouZuo from '@web-common/images/newIcon/tongyong_jiantou_zuo.svg';
import WarnIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import ClearIcon from '@/images/icons/edm/yingxiao/edm-content-preview-clear.svg';
import EditIcon from '@/images/icons/edm/yingxiao/edm-content-preview-edit.svg';
import { MailTemplateListV2 } from '../mailTemplate/MailTemplateListV2/MailTemplateListV2';
import { TemplateListV2 } from '../mailTemplate/TemplateListV2';
import { TaskList } from '../mailTemplate/TaskList';
import useState2SalesPitchReduxMock from '@/components/Layout/EnterpriseSetting/salesPitch/utils/useState2ReduxMock';
import { useSignSiteGuide, SignSiteGuide } from '@web-common/components/UI/LxEditor/SignSiteGuide/index';
import { edmOperateVarBeforeSend } from '@web-mail-write/components/SendMail/utils';
import { addDataSrcForImg } from './utils/getMailContentText';
export const ContentProduct = 'product';
export const ContentCompany = 'company';
export const ContentRoot = React.forwardRef((props, ref) => {
    const { onUseAi, qs, isCopyHeader, setUseContentAssistant, configEmailSubject, visible, attachmentList, content, signature = '', canShowHistoryModal, onReady, editorRef, onTypeChange, onPreviewVariable, setIsEdited, contentOnChange, onAttachmentChange, } = props;
    const prevScene = new URLSearchParams(location.href).get('from') || 'newCreate';
    const sceneActionType = new URLSearchParams(location.href).get('action');
    const [type, setType] = useState('template');
    const [allowSend, setAllowSend] = useState(true);
    const [previewData, setPreviewData] = useState('');
    const [originalData, setOriginalData] = useState('');
    useEffect(() => {
        if (guardString(previewData) || isStartEditor()) {
            setIsEdited && setIsEdited(true);
        }
    }, [type, previewData]);
    const [showExitConfirm, setShowExitConfirm] = useState(false);
    const [showTemplateMoreModal, setShowTemplateMoreModal] = useState(false);
    const recentTemplateRef = useRef();
    const listInfoRef = useRef();
    const [useTemplate, setUseTemplate] = useState({ use: false });
    const [curListType, setCurListType] = useState();
    const [showSiteGuideState, setShowSiteGuideState] = useState(false);
    const { signDOMRect, signLinkHandlers } = useSignSiteGuide({
        showSiteGuideState: showSiteGuideState,
        setShowSiteGuideState: setShowSiteGuideState,
    });
    const { updateEdmSingleTaskHasNewCreated } = useActions(MailProductActions);
    useEffect(() => {
        setPreviewData(edmOperateVarBeforeSend(content, true));
    }, [content]);
    useEffect(() => {
        if (showSiteGuideState) {
            edmDataTracker.track('pc_mail_signature_site_guide_view', {
                type: '2',
            });
        }
    }, [showSiteGuideState]);
    const checkContent = useCallback(debounce((content) => {
        if (guardString(content)) {
            const result = checkContentSize(content);
            setAllowSend(result);
            if (!result) {
                message.error(getIn18Text('YOUJIANNEIRONGZUIDUOZHI'));
            }
        }
    }, 300), []);
    useEffect(() => {
        if (prevScene === 'mySite' ||
            (prevScene === 'deliverCenter' && ['insertSubscribeBtn', 'showProductSelectModal', 'showLandingPageInsetModal', 'showSiteLinkBtnEntry'].includes(sceneActionType))) {
            setType('write');
        }
    }, []);
    useEffect(() => {
        var _a;
        onTypeChange && onTypeChange(type);
        if (isStartEditor()) {
            signLinkHandlers((_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.getEditor(), 'marketingTask');
        }
    }, [type]);
    useEffect(() => {
        checkContent(previewData);
    }, [previewData]);
    useEffect(() => {
        if ((qs === null || qs === void 0 ? void 0 : qs.cphd) === '1') {
            setPreviewData('');
        }
    }, [qs]);
    const [, setEdmTemplateOuterDrawerVisible] = useState2SalesPitchReduxMock('edmTemplateOuterDrawerVisible');
    const [edmTemplateSalesPitch, setEdmTemplateSalesPitch] = useState2SalesPitchReduxMock('edmTemplateSalesPitch');
    useEffect(() => {
        var _a;
        if (edmTemplateSalesPitch && edmTemplateSalesPitch.discourseContent) {
            (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.insertContent(edmTemplateSalesPitch.discourseContent || '');
            setTimeout(() => {
                setEdmTemplateSalesPitch(null);
            }, 1000);
        }
    }, [edmTemplateSalesPitch === null || edmTemplateSalesPitch === void 0 ? void 0 : edmTemplateSalesPitch.discourseContent]);
    const exitConfirmComp = () => {
        return (React.createElement(SiriusModal, { closable: true, width: 400, visible: showExitConfirm, footer: null, onCancel: () => setShowExitConfirm(false) },
            React.createElement("div", { className: style.saveConfirmHeader },
                React.createElement(WarnIcon, { style: { marginRight: 8, verticalAlign: -4 } }),
                getIn18Text('YIBIANJINEIRONGSHANGWEI')),
            React.createElement("div", { className: style.secondBtns },
                React.createElement(Button, { btnType: "minorLine", onClick: onSave }, getIn18Text('BAOCUNNEIRONGBINGFANHUI')),
                React.createElement(Button, { onClick: () => {
                        setShowExitConfirm(false);
                        resetOriginalData();
                        setType('template');
                    }, btnType: "primary", key: "save" }, getIn18Text('QUERENFANHUI')))));
    };
    const isStartEditor = () => {
        return type === 'write' || type === ContentProduct || type === ContentCompany;
    };
    const siteGuide = () => {
        return showSiteGuideState ? (React.createElement(Popover, { content: React.createElement(SignSiteGuide, { signModalId: "selectSignOnWaimao", onClose: () => {
                    setShowSiteGuideState(false);
                } }), visible: true, placement: "rightTop", overlayClassName: "sign-site-guide-popover", getPopupContainer: node => node, autoAdjustOverflow: false },
            React.createElement("div", { style: {
                    position: 'absolute',
                    left: signDOMRect === null || signDOMRect === void 0 ? void 0 : signDOMRect.x,
                    top: signDOMRect === null || signDOMRect === void 0 ? void 0 : signDOMRect.y,
                    width: signDOMRect === null || signDOMRect === void 0 ? void 0 : signDOMRect.width,
                    height: signDOMRect === null || signDOMRect === void 0 ? void 0 : signDOMRect.height,
                } }))) : null;
    };
    const onSave = () => {
        let content = getEditorContent();
        setPreviewData(content);
        setShowExitConfirm(false);
        setType('template');
    };
    const getEditorContent = () => {
        var _a;
        let content = ((_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.getContent()) || '';
        return content;
    };
    const resetOriginalData = () => {
        var _a;
        setPreviewData(originalData);
        (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.setContent(originalData || signature);
    };
    const signLinkHandlersCallback = useCallback(() => {
        var _a;
        const refEditor = (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.getEditor();
        signLinkHandlers(refEditor, 'marketingTask');
    }, []);
    const changeEditor = () => {
        signLinkHandlersCallback();
        contentOnChange && contentOnChange();
    };
    const contentEditorComp = () => {
        var _a;
        return (React.createElement("div", { className: style.writeWrap, style: { display: isStartEditor() ? undefined : 'none' } },
            React.createElement("div", { className: style.back, onClick: () => {
                    setShowExitConfirm(true);
                } },
                React.createElement("img", { src: TongyongJiantouZuo }),
                getIn18Text('FANHUINEIRONGKU')),
            React.createElement(ContentEditor, { onUseAi: report => {
                    onUseAi && onUseAi(report);
                }, showInteractVar: true, isCopyHeader: isCopyHeader, exactSource: "writeSend", readonly: false, imgProductRemind: true, setUseContentAssistant: setUseContentAssistant, configEmailSubject: configEmailSubject, emailSubject: (_a = props.qs) === null || _a === void 0 ? void 0 : _a.emailSubject, visible: isStartEditor(), type: type, ref: editorRef, writeFlow: true, attachmentList: attachmentList, content: cloneDeep(previewData), signature: signature, canShowHistoryModal: canShowHistoryModal, contentOnChange: changeEditor, onPreviewVariable: onPreviewVariable, insertContentProductImgCallback: hasNewCreated => hasNewCreated && updateEdmSingleTaskHasNewCreated(true), onReady: info => {
                    var _a;
                    onReady && onReady();
                    if (info) {
                        let content = getEditorContent();
                        setPreviewData(content || '');
                        onUseTemplate(info.templateId, info.templateContent);
                        if (info.templateId) {
                            setOriginalData(previewData);
                            setType('write');
                            let t = Object.assign(Object.assign({}, useTemplate), { changed: true, use: guardString(info.templateId) ? true : false, id: info.templateId });
                            setUseTemplate(t);
                        }
                    }
                    signLinkHandlers((_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.getEditor(), 'marketingTask');
                }, salespitchActionAction: () => {
                    setEdmTemplateOuterDrawerVisible(true);
                }, siteGuide: siteGuide, showProductVariable: false, onAttachmentChange: onAttachmentChange })));
    };
    const refreshRecent = () => {
        var _a;
        (_a = recentTemplateRef.current) === null || _a === void 0 ? void 0 : _a.refresh(false);
    };
    useEffect(() => {
        if (showTemplateMoreModal === false) {
            refreshRecent();
        }
    }, [showTemplateMoreModal]);
    useImperativeHandle(ref, () => ({
        fetchAllowSend() {
            return allowSend;
        },
        fetchTemplateInfo() {
            return Object.assign(Object.assign({}, useTemplate), { type: curListType });
        },
    }));
    const RecentTemplateModalComp = () => {
        var _a, _b, _c, _d, _e;
        return (React.createElement(SiriusModal, { className: style.modal, width: 900, title: ((_a = listInfoRef.current) === null || _a === void 0 ? void 0 : _a.title) || '内容库', destroyOnClose: true, footer: null, centered: true, maskClosable: false, visible: showTemplateMoreModal, onCancel: () => {
                refreshRecent();
                setShowTemplateMoreModal(false);
            } },
            ((_b = listInfoRef.current) === null || _b === void 0 ? void 0 : _b.listType) !== 'task' && (React.createElement(TemplateListV2, { isFormWrite: true, listType: (_c = listInfoRef.current) === null || _c === void 0 ? void 0 : _c.listType, tabId: ((_d = listInfoRef.current) === null || _d === void 0 ? void 0 : _d.id) || 0, onUse: (id, content) => {
                    var _a;
                    setShowTemplateMoreModal(false);
                    onUseTemplate(id, content);
                    setCurListType((_a = listInfoRef.current) === null || _a === void 0 ? void 0 : _a.listType);
                    setOriginalData(previewData);
                    setType('write');
                    let info = Object.assign(Object.assign({}, useTemplate), { changed: true, use: guardString(id) ? true : false, id: id });
                    setUseTemplate(info);
                } })),
            ((_e = listInfoRef.current) === null || _e === void 0 ? void 0 : _e.listType) === 'task' && (React.createElement(TaskList, { isFormWrite: true, onUse: (id, content) => {
                    setShowTemplateMoreModal(false);
                    onUseTemplate(id, content);
                    setCurListType('task');
                } }))));
    };
    const onUseTemplate = (templateId, content) => {
        if (guardString(templateId)) {
            setUseTemplate({ use: true, id: templateId });
            let html = document.createElement('div');
            html.innerHTML = (content || '') + signature;
            html = addDataSrcForImg(html);
            setPreviewData(html.innerHTML || '');
        }
        else {
            setUseTemplate({ use: false, id: undefined });
            setPreviewData(content || '');
            edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                type: 'useTask',
            });
        }
    };
    const RecentTemplateComp = () => {
        return (React.createElement("div", { className: style.templateRoot },
            React.createElement(MailTemplateListV2, { ref: recentTemplateRef, onUse: (id, contentOrg, listType) => {
                    const content = edmOperateVarBeforeSend(contentOrg, true);
                    onUseTemplate(id, content);
                    setCurListType(listType);
                    if (listType !== 'task') {
                        setOriginalData(previewData);
                        setType('write');
                        let info = Object.assign(Object.assign({}, useTemplate), { changed: true, use: guardString(id) ? true : false, id: id });
                        setUseTemplate(info);
                    }
                }, showMore: (title, listType, id) => {
                    listInfoRef.current = {
                        id,
                        title,
                        listType,
                    };
                    setShowTemplateMoreModal(true);
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'more',
                    });
                }, isFormWrite: true })));
    };
    const WriteEmptyComp = () => {
        return (React.createElement("div", { className: style.writeEmpty },
            React.createElement("div", { className: style.writeEmptyItem, onClick: () => {
                    setOriginalData(previewData);
                    setType('write');
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'newContent',
                    });
                    edmDataTracker.track('pc_markting_edm_single_create_type', {
                        type: 'blank',
                    });
                } },
                React.createElement("div", { className: style.writeEmptyItemTop },
                    React.createElement("div", { className: style.writeEmptyItemTopPlus }),
                    React.createElement("div", { className: style.writeEmptyItemTopTitle }, getIn18Text('CHUANGJIANKONGBYJ'))),
                React.createElement("div", { className: style.writeEmptyItemDetail }, getIn18Text('CONG0KSCJSYNZJDGXHYX2'))),
            React.createElement("div", { className: style.writeEmptyItem, onClick: () => {
                    setOriginalData(previewData);
                    setType(ContentProduct);
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'newContent',
                    });
                    edmDataTracker.track('pc_markting_edm_single_create_type', {
                        type: 'product',
                    });
                } },
                React.createElement("div", { className: style.writeEmptyItemTop },
                    React.createElement("div", { className: style.writeEmptyItemTopPlus }),
                    React.createElement("div", { className: style.writeEmptyItemTopTitle }, getIn18Text('CHUANGJIANSHANGPYXYJ'))),
                React.createElement("div", { className: style.writeEmptyItemDetail }, getIn18Text('ZAIYOUJIANZTJSPLJYDQ15'))),
            React.createElement("div", { className: style.writeEmptyItem, onClick: () => {
                    setOriginalData(previewData);
                    setType(ContentCompany);
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'newContent',
                    });
                    edmDataTracker.track('pc_markting_edm_single_create_type', {
                        type: 'landing_page',
                    });
                } },
                React.createElement("div", { className: style.writeEmptyItemTop },
                    React.createElement("div", { className: style.writeEmptyItemTopPlus }),
                    React.createElement("div", { className: style.writeEmptyItemTopTitle }, getIn18Text('CHUANGJIANGONGSXCYJ'))),
                React.createElement("div", { className: style.writeEmptyItemDetail }, getIn18Text('ZAIYOUJIANZTJLDYTGGJ27')))));
    };
    const WritePreviewComp = () => {
        return (React.createElement("div", { className: style.writePreview },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: previewData || '' } })));
    };
    const WriteActionComp = () => {
        return (React.createElement("div", { className: style.actionCover },
            React.createElement("div", { className: style.actionButton, onClick: () => {
                    setOriginalData(previewData);
                    setType('write');
                    edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                        type: 'editContent',
                    });
                    let info = Object.assign(Object.assign({}, useTemplate), { changed: true });
                    setUseTemplate(info);
                } },
                React.createElement("img", { src: EditIcon }),
                React.createElement("div", { className: style.title }, getIn18Text('BIANJIYOUJIANNEIRONG'))),
            React.createElement(Popover, { overlayClassName: style.hoverPopover, placement: "top", destroyTooltipOnHide: true, content: React.createElement("div", { className: style.hoverView },
                    React.createElement("div", { className: style.hoverViewButton, onClick: () => {
                            setOriginalData(previewData);
                            setType('write');
                            setPreviewData(signature);
                            edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                                type: 'changeNew',
                            });
                            edmDataTracker.track('pc_markting_edm_single_create_type', {
                                type: 'blank',
                            });
                            let info = Object.assign(Object.assign({}, useTemplate), { changed: true });
                            setUseTemplate(info);
                        } }, getIn18Text('CHUANGJIANKONGBYJ')),
                    React.createElement("div", { className: style.hoverViewButton, onClick: () => {
                            setOriginalData(previewData);
                            setType(ContentProduct);
                            setPreviewData(signature);
                            edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                                type: 'changeNew',
                            });
                            edmDataTracker.track('pc_markting_edm_single_create_type', {
                                type: 'product',
                            });
                            let info = Object.assign(Object.assign({}, useTemplate), { changed: true });
                            setUseTemplate(info);
                        } }, getIn18Text('CHUANGJIANSHANGPYXYJ')),
                    React.createElement("div", { className: style.hoverViewButton, onClick: () => {
                            setOriginalData(previewData);
                            setType(ContentCompany);
                            setPreviewData(signature);
                            edmDataTracker.track('pc_markting_edm_taskCreate_contentSet', {
                                type: 'changeNew',
                            });
                            edmDataTracker.track('pc_markting_edm_single_create_type', {
                                type: 'landing_page',
                            });
                            let info = Object.assign(Object.assign({}, useTemplate), { changed: true });
                            setUseTemplate(info);
                        } }, getIn18Text('CHUANGJIANGONGSXCYJ'))) },
                React.createElement("div", { className: style.actionButton },
                    React.createElement("img", { src: ClearIcon }),
                    React.createElement("div", { className: style.title }, getIn18Text('QINGCHUBINGXINJIANYOUJIAN'))))));
    };
    const WriteContentComp = () => {
        return (React.createElement("div", { className: style.writeRoot },
            React.createElement("div", { className: classnames(style.content, guardString(previewData) ? style.content2 : '') },
                !guardString(previewData) && WriteEmptyComp(),
                guardString(previewData) && WritePreviewComp()),
            guardString(previewData) && WriteActionComp()));
    };
    let WriteMode = isStartEditor();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.root, style: Object.assign({ display: visible ? 'flex' : 'none' }, (!WriteMode
                ? {
                    overflow: 'hidden',
                }
                : {})) },
            !WriteMode && RecentTemplateComp(),
            !WriteMode && WriteContentComp(),
            contentEditorComp()),
        exitConfirmComp(),
        RecentTemplateModalComp()));
});
